// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2tF96","choiceBoxes":"toolbarselects_choiceBoxes__-7Vps","simpleField":"toolbarselects_simpleField__cwV22"};